import { AlternativeData } from "@/types";
import styles from "./css/AlternativeEnergy.module.css";
import { EnergyContent } from "./EnergyContent";
import { ModelView } from "@/components/files/ModelView";

interface AlternativeEnergyProps {
    alternative: AlternativeData;
}

export const AlternativeEnergy = ({ alternative }: AlternativeEnergyProps) => {



const consumptionColors = {
    energy_consumption: {
      "Value1": "#007AFF",
      "Value2": "#FF2D55",
      "Value3": "#FFCC00",
      "Value4": "#00C7BE",
    },
    energyProduction: {
        "Value1": "#34C759",
        "Value2": "#007AFF",
        "Value3": "#FFCC00",
        "Value4": "#00C7BE",
    },
    vehicleCharging: {
        "Value1": "#00C7BE",
        "Value2": "#007AFF",

      }
    }


    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <EnergyContent 

                    consumptionColors={consumptionColors}
                    alternative={alternative}
                    layout="row"
                />
            </div>
          
        </div>
    );
}